export const FETCH_REQUESTS = 'FETCH_REQUESTS';

export const requestsAction = (requests) => ({
  type: FETCH_REQUESTS,
  payload: requests
});

